var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloudLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 11.4934H12.3745C14.0933 11.4934 15.4995 10.5806 15.4995 8.88091C15.4995 7.18122 13.8433 6.33497 12.4995 6.26841C12.2217 3.61028 10.2808 1.99341 7.99951 1.99341C5.84326 1.99341 4.45451 3.42435 3.99951 4.84341C2.12451 5.02153 0.499512 6.21466 0.499512 8.16841C0.499512 10.1222 2.18701 11.4934 4.24951 11.4934H5.99951",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 7.99369L8.00004 5.99341L5.99976 7.99369",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 14.0065V6.49341",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloudLight);
export default __webpack_public_path__ + "static/media/ic-cloud-light.d747174b9a10cc5913a5e3adeafe284e.svg";
export { ForwardRef as ReactComponent };